import { useState, useEffect } from "react";
import Form from "./movementForm.view";
import { useReadLocation } from "../hook/useReadLocation";
import { useReadBigBag } from "../../standAloneProcess/hook/useReadBigBag";
import * as StockService from "../../../../services/StockServices";
import * as MovementService from "../../../../services/MovementServices";
import { STOCK_STATUS_PRODUCED } from "../../../../constants";
import showDialog from "../../../utils/ShowDialog/ShowDialog";
import { useTranslation } from "react-i18next";
import PATHS from "../../../../constants/paths";
import { useNavigate } from "react-router";

const MovementContainer = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [entryLocation, setentryLocation] = useState(null);
  const [dataBatch, setDataBatch] = useState(null);
  const [stock, setStock] = useState(null);
  const { readLocation, location } = useReadLocation();
  const { simpleReadBigBag, initial } = useReadBigBag();

  useEffect(() => {
    setentryLocation(location);
  }, [location]);

  useEffect(() => {
    if (initial?.outBatch) {
      StockService.listFilterStock({
        filters: {
          batch: initial.outBatch,
          status: STOCK_STATUS_PRODUCED.code,
        },
      }).then((result) => {
        if (result && result.docs.length > 0) {
          setDataBatch(initial);
          setStock(result.docs[0]);
        } else {
          showDialog(
            t("forms.process.messages.movement.title"),
            t("forms.process.messages.movement.errorStockText"),
            "error",
            false,
            "Ok"
          );
        }
      });
    }
  }, [initial]);

  const handlerConfirm = async () => {
    try {
      const result = await MovementService.confirmMovement(
        dataBatch.outBatch,
        entryLocation.code
      );
      if (result) {
        const okAction = () => {
          navigate(PATHS.HOME);
        };

        showDialog(
          t("forms.process.messages.movement.title"),
          t("forms.process.messages.movement.successText"),
          "success",
          false,
          "OK",
          false,
          okAction
        );
      }
    } catch (error) {}
  };

  return (
    <>
      {!entryLocation && readLocation()}
      {entryLocation && !dataBatch?.outBatch && simpleReadBigBag()}
      {entryLocation && dataBatch?.outBatch && (
        <Form
          entryLocation={entryLocation}
          dataBatch={dataBatch}
          stock={stock}
          confirm={handlerConfirm}
        />
      )}
    </>
  );
};

export default MovementContainer;
